import { Image, type ImageProps } from "@chakra-ui/react";
import * as React from "react";

export interface LogoProps extends Omit<ImageProps, "src"> {}

export const Logo = (props: LogoProps) => {
  return <Image src="/static/img/logo.png" {...props} />;
};
